var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import WebComponentFactory from './WebComponentFactory';
import includePolyfills from './helpers/polyfillHandler';
let _resolve;
const callback = (element) => {
    _resolve === null || _resolve === void 0 ? void 0 : _resolve(element);
};
class DireflowComponent {
    /**
     * Create muliple Direflow Components
     * @param App React Component
     */
    static createAll(componentConfigs) {
        return componentConfigs.map(DireflowComponent.create);
    }
    /**
     * Create Direflow Component
     * @param App React Component
     */
    static create(componentConfig) {
        const { component } = componentConfig;
        const plugins = component.plugins || componentConfig.plugins;
        const configuration = component.configuration || componentConfig.configuration;
        if (!component) {
            throw Error('Root component has not been set');
        }
        if (!configuration) {
            throw Error('No configuration found');
        }
        const componentProperties = Object.assign(Object.assign(Object.assign({}, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.properties), component.properties), component.defaultProps);
        const tagName = configuration.tagname || 'direflow-component';
        const shadow = configuration.useShadow !== undefined ? configuration.useShadow : true;
        const anonymousSlot = configuration.useAnonymousSlot !== undefined ? configuration.useAnonymousSlot : false;
        (() => __awaiter(this, void 0, void 0, function* () {
            /**
             * TODO: This part should be removed in next minor version
             */
            yield Promise.all([includePolyfills({ usesShadow: !!shadow }, plugins)]);
            const WebComponent = new WebComponentFactory(componentProperties, component, shadow, anonymousSlot, plugins, callback).create();
            customElements.define(tagName, WebComponent);
        }))();
        return {
            then: (resolve) => __awaiter(this, void 0, void 0, function* () {
                if (resolve) {
                    _resolve = resolve;
                }
            }),
        };
    }
}
export default DireflowComponent;
